import React from 'react';
import strings from 'utils/strings';
import AlertBox from 'components/CreateNotification/alert';
import markTest from 'api/markTest';

class MarkTestConfirmation extends React.Component {
	constructor(props) {
		super(props);

		// Safely extract testUser from selectedTestUser array
		const [{key = null} = {}] = this.props.selectedTestUser || [];

		this.state = {
			testKey: key,
			showAlert: false,
			success: null,
			message: '',
			isConfirmedDisabled: false,
		};
	}

	// Save the updated JSON
	onConfirm = () => {
		this.setState({isConfirmedDisabled: true});

		markTest({
			markTest: this.props.markTest,
			testKey: this.state.testKey,
		}).then((res) => {
			if (!res) {
				this.setState({
					showAlert: true,
					success: false,
					message: 'Ops! something went wrong.',
				});
			} else {
				this.props.getTestsBySearch({testKey: this.state.testKey});
				this.setState({
					showAlert: true,
					success: true,
					message: 'Test information updated successfully',
				});
			}

			setTimeout(() => {
				this.setState({showAlert: false});
				this.props.onMarkTestModelConfirm();
			}, 3000);
		});
	};

	// Cancel editing
	onCancel = () => {
		this.props.onMarkTestModelCancel();
		this.setState({
			error: null,
			success: null,
			message: '',
		});
	};

	render() {
		const {jsonError, showAlert, message, success} = this.state;

		return (
			<div
				className="lit-modal"
				onClick={() => this.props.onDeleteModelCancel()}
			>
				<div
					className="lit-modal__other"
					onClick={(event) => event.stopPropagation()}
				>
					<div>
						<h3>Mark Test</h3>
					</div>
					<p style={{marginBottom: '15px'}}>
						Are you sure you want to mark this test?
					</p>
					<div className="lit-post-notification-btn-div">
						<button
							className="lit-btn bg-primary"
							disabled={jsonError}
							onClick={this.onConfirm}
						>
							{strings.confirm}
						</button>

						<button
							className="lit-btn bg-negative"
							onClick={this.onCancel}
						>
							{strings.cancel}
						</button>
					</div>

					{showAlert && (
						<AlertBox
							type={success ? 'success' : 'error'}
							message={message}
						/>
					)}
				</div>
			</div>
		);
	}
}

export default MarkTestConfirmation;
